import React from 'react'
import SelectField from '../input/SelectField'
import useFetchData from '../../../hooks/useFetchData'

const SelectFieldYears = ({ id, name, value, onChange, error, disabled }) => {
  const { isLoading, data, error: errorFetch } = useFetchData('setting/year')

  return (
    <SelectField
      id={id}
      error={errorFetch || error}
      helperText={errorFetch || error}                    
      value={value}
      name={name}
      onChange={onChange}      
      options={data?.map(item => ({ value: item._id, label: item.name })) || []}
      placeholder="Choose a year level"
      loading={isLoading}
      disabled={isLoading || disabled}
    />  
  )
}

export default SelectFieldYears